webpackJsonp([1],{

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Media__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Media__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Media___default.a);

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GridItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GridItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GridItem__);
/* unused harmony reexport Grid */
/* unused harmony reexport GridItem */





/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var ALIGN_VALUES = ['bottom', 'middle'];
var SIZE_VALUES = ['flush', 'tiny', 'small', 'large', 'huge'];
var SPACE_VALUES = ['around', 'between', 'center', 'end'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Grid',
  props: {
    align: {
      type: String,
      validator: function validator(value) {
        return ALIGN_VALUES.includes(value);
      }
    },
    size: {
      type: String,
      validator: function validator(value) {
        return SIZE_VALUES.includes(value);
      }
    },
    space: {
      type: String,
      validator: function validator(value) {
        return SPACE_VALUES.includes(value);
      }
    },
    stretch: {
      type: Boolean,
      default: false
    },
    auto: {
      type: Boolean,
      default: false
    },
    liquid: {
      type: Boolean,
      default: false
    },
    reverse: {
      type: Boolean,
      default: false
    },
    wrapped: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Grid-item',
  props: {
    width: {
      type: String,
      validator: function validator(value) {
        var split = value.split('/');
        return value.match(/^[1-9]\/[1-9]$/g) && split[0] <= split[1];
      }
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    computedStyle: function computedStyle() {
      if (!this.width) return null;

      return { width: this.getWidthFromFraction(this.width) };
    }
  },
  methods: {
    getWidthFromFraction: function getWidthFromFraction(fraction) {
      var split = fraction.split('/');
      var result = parseInt(split[0]) / parseInt(split[1]);

      return this.round(result, 5) * 100 + '%';
    },
    round: function round(value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
    }
  }
});

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var VALIGN_VALUES = ['center', 'bottom', 'stretch'];
var SIZE_VALUES = ['flush', 'tiny', 'small', 'large', 'huge'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Media',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    reverse: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      validator: function validator(value) {
        return SIZE_VALUES.includes(value);
      }
    },
    align: {
      type: String,
      validator: function validator(value) {
        return VALIGN_VALUES.includes(value);
      }
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(52),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(49),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(50),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 49:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-grid__item",
    style: (_vm.computedStyle)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Media__ = __webpack_require__(1);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Media", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Media__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Grid__ = __webpack_require__(13);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_1__components_Grid__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GridItem", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Media__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Block", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Media__["a"]; });





/***/ }),

/***/ 50:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-media",
    class: [
      _vm.align && ("o-media--" + _vm.align),
      _vm.size && ("o-media--" + _vm.size),
      {
        'o-media--reverse': _vm.reverse
      }
    ]
  }, [_c('div', {
    staticClass: "o-media__img"
  }, [_c('img', _vm._b({}, 'img', {
    src: _vm.src,
    alt: _vm.alt
  }, false))]), _vm._v(" "), _c('div', {
    staticClass: "o-media__body"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-grid",
    class: [
      _vm.align && ("o-grid--" + _vm.align),
      _vm.size && ("o-grid--" + _vm.size),
      _vm.space && ("o-grid--" + _vm.space),
      {
        'o-grid--stretch': _vm.stretch,
        'o-grid--wrapped': _vm.wrapped,
        'o-grid--liquid': _vm.liquid,
        'o-grid--auto o-grid--liquid': _vm.auto,
        'o-grid--reverse': _vm.reverse
      }
    ]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ })

},[5]);


// WEBPACK FOOTER //
// docs/js/vue-objects.afba81d28a5bff8b8833.js